<template>
  <v-dialog v-model="dialogModel" persistent max-width="730" content-class="elevation-0">
    <v-card width="730" height="330" color="white" class="sigfloCard borderImage elevation-0">
      <v-card-text class="textContainer d-flex flex-column justify-center">
        <v-img class="sigfloLogo" src="@/assets/images/sigfloSymbolLogo.svg" height="142" width="142" />
        <div class="title sigfloH4 textEmphasis mb-1">{{ title }}</div>
        <div class="message sigfloBody400 textDefault mb-4">
          {{ message }}
        </div>
        <div class="buttons">
          <v-btn
            rounded
            elevation="0"
            color="#7C40DC"
            class="mr-4 capitalize--text sigfloButtonSmall600"
            dark
            @click="$emit('close')"
          >
            <v-icon class="mr-2"> mdi-thumb-up-outline </v-icon>
            Got it!
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      title: {
        Type: String,
        required: true
      },
      message: {
        type: String,
        required: true
      },
      dialogModel: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {};
    }
  };
</script>

<style scoped>
  .borderImage {
    border: 0px solid transparent !important;
    background-image: url('~@/assets/images/dialogRightBorder.svg');
    background-position: right top; /* Align the image to the top right */
    background-repeat: no-repeat; /* Prevent the image from repeating */
  }
  .dialogRightBorder {
    position: absolute;
    right: 0;
    top: 0;
  }
  .textContainer {
    margin-left: 200px;
    height: 330px;
  }

  .message {
    width: 400px;
  }

  .sigfloLogo {
    position: absolute;
    left: 48px;
    top: 76px;
  }
</style>
